import moment from "moment";
import { formatearFecha } from "../../helpers/formato";

// Piezas que comparten la lista de créditos y el detalle del crédito.

// El servidor manda 0001-01-01 cuando una fecha no existe (p. ej. la entrega de un crédito
// que aún no se desembolsa): se muestra "—" en vez de "01/01/0001".
export const fechaDeCredito = (fecha) => {
  const m = moment(fecha);
  if (!m.isValid() || m.year() <= 1) return "—";
  return formatearFecha(fecha);
};

// Encabezado de tabla: texto en primary, en negrita y sin partirse en dos líneas.
export const encabezadoTabla = {
  fontWeight: 700,
  color: "primary.main",
  whiteSpace: "nowrap",
};

// Columnas de montos: a la derecha y con cifras tabulares.
export const celdaMonto = {
  textAlign: "right",
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
};

export const celdaFecha = {
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
};

// Estado de un crédito para `EstadoChip`, con lo que ya se carga.
// `mora` es true/false cuando el plan de pagos ya se cargó, y null/undefined si aún no se sabe
// (en la lista no se conoce): en ese caso un crédito vigente no afirma estar "al día".
export const estadoDeCredito = (credito, mora = null) => {
  if (!credito) return { estado: "neutro", label: "Sin estado" };
  if (credito.isEntregado === false) {
    return { estado: "aviso", label: "Pendiente de entrega" };
  }
  if (credito.isCanceled) return { estado: "neutro", label: "Cancelado" };
  if (mora === true) return { estado: "mora", label: "En mora" };
  if (mora === false) return { estado: "ok", label: "Al día" };
  return { estado: "info", label: "Vigente" };
};

// Una cuota está vencida si no se ha pagado y su fecha ya pasó (la de hoy aún no).
export const cuotaVencida = (cuota) =>
  !cuota.isCanceled && moment(cuota.fechaPago).isBefore(moment(), "day");
